
class ForgotPasswordViewController extends MUIViewController
{
    static newInstance() : ForgotPasswordViewController {
        let vc = new ForgotPasswordViewController('forgot-password-view');
        vc.initWithResource("layout/forgot_password/ForgotPasswordView.html");
        return vc;
    }

    private cancelButton:MUIButton = null;
    private createButton:MUIButton = null;

    private emailTextField:MUITextField = null;

    viewDidLoad()
    {
        super.viewDidLoad();

        this.emailTextField = MUIOutlet(this, 'email-tf', 'MUITextField');
 
        this.cancelButton = MUIOutlet(this, 'cancel-btn','MUIButton');
        this.cancelButton.setAction(this, function(){            
            this.navigationController.popViewController(true);
        });

        this.createButton = MUIOutlet(this, 'recover-btn', 'MUIButton');
        this.createButton.setAction(this, function() {
            let auth = DualLinkAuthKit.sharedInstance();
            auth.rememberPassword(this.emailTextField.text, MIOCoreGetBrowserLanguage(), (json:any, error:Error) => {
                if(error == null)
                    this.navigationController.popViewController(true);
                else {
                    AppHelper.showErrorMessage(this, "ERROR", MIOLocalizeString("THERE_WAS_AN_ERROR_SENDING_THE_REMINDER", "There was an error sending the reminder"));
                }
            });
            
        });

    }
}